import "styles/App.scss"
import {BrowserRouter as Router, Routes, Route, Navigate} from "react-router-dom"

import {useAuth0} from "@auth0/auth0-react"
import {Navbar} from "components/Navbar"
import {MenuBar} from "components/MenuBar"
import {Header} from "components/Header"
import {pagesDashboards} from "constants/constants"
import {LoadingOverlay} from "components/LoadingOverlay"
import {useEffect, useState} from "react"
import isOnline from "is-online"
import {Box} from "@mui/material"

import {StartPage} from "pages/StartPage/StartPage"
import { Subscription } from "pages/Subscription"

function App() {
  const {isLoading, error, isAuthenticated} = useAuth0()
  const [onlineStatus, SetOnlineStatus] = useState()

  useEffect(() => {
    CheckingInternet()
  }, [])

  async function CheckingInternet() {
    const online = await isOnline()

    if (online) {
      SetOnlineStatus(true)
      // console.log(" Localhost подключен к интернету. ")
      return
    }

    if (!online) {
      SetOnlineStatus(false)
      console.log(
        "There is no Internet connection. The operation to update the settings has been skipped."
      )
      return false
    }
  }

  return (
    <>
      {!onlineStatus && <p>No internet connection.</p>}
      {onlineStatus && error && <p>Authentication Error</p>}

      {!error && isLoading && <LoadingOverlay />}

      {!isAuthenticated && (
        <>
          <Router>
            <Navbar />
            <Routes>
              <Route path="/welcome" element={<StartPage />} />
              <Route path="*" element={<StartPage />} />
            </Routes>
          </Router>
        </>
      )}

      {!error && !isLoading && isAuthenticated && (
        <>
          <Router>
            <Box sx={{ display: "flex" }}>
              <MenuBar />
              <Box
                component="main"
                sx={{
                  flexGrow: 1,
                  minHeight: "100vh",
                  width: "100%",
                  "@media(max-width: 1024px)": {
                    marginLeft: 0,
                  },
                }}
              >
                <Navbar />
                <Header />

                <Routes>
                  <Route path={'/subscription'} element={<Subscription />} />
                  <Route path="/" element={<Navigate to="/home" replace />} />
                  <Route path="/welcome" element={<Navigate to="/home" replace />} />

                  {pagesDashboards.map((page, index) => (
                    <Route key={index} path={page.href} element={page.element} />
                  ))}
                </Routes>
              </Box>
            </Box>
          </Router>
        </>
      )}
    </>
  )
}

export default App
